<button
  class="inline-flex items-center gap-2 text-sm font-medium transition-all duration-200 ease-in-out shadow-theme-xs"
  [type]="type"
  [disabled]="disabled"
  [ngClass]="getClasses()"
>
  @if (icon) {
    <lucide-icon [name]="icon" size="20"></lucide-icon>
  }
  {{ label }}
</button>
